import { render, staticRenderFns } from "./order.page.vue?vue&type=template&id=196a853c&"
import script from "./order.page.vue?vue&type=script&lang=js&"
export * from "./order.page.vue?vue&type=script&lang=js&"
import style0 from "./order.page.vue?vue&type=style&index=0&id=196a853c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports